module.exports = __webpack_public_path__ + "img/logo.0fb3cfc5.png";